export enum TipoIniciacao {
	QRCODE_ESTATICO = 'QRCODE_ESTATICO',
	QRCODE_DINAMICO = 'QRCODE_DINAMICO',
	CHAVE_PIX = 'CHAVE_PIX',
	NAO_INFORMADO = 'NAO_INFORMADO',
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/tipo-iniciacao.enum.ts